import axios from 'axios'
import { useTokenInterceptor } from 'interceptors/tokenInterceptor'
import { SESSION_TOKEN_STORAGE } from 'storage/sessionTokenStorage'

const baseURL = process.env.REACT_APP_PDF_EXPRESS

export const pdfExpress = axios.create({
  baseURL,
})

pdfExpress.interceptors.request.use((config) =>
  useTokenInterceptor(config, SESSION_TOKEN_STORAGE.get()),
)
